import { connect } from 'react-redux';
import { getPageLocale, getPath } from 'store/modules/page';
import HeaderSearch from 'components/StorageMartHeaderSearch';
import { searchingFacilities, facilitiesLoaded } from 'store/modules/facilities';

const mapStateToProps = state => ({
  locale: getPageLocale(state),
  pathname: getPath(state),
  searching: searchingFacilities(state),
  facilitiesLoaded: facilitiesLoaded(state),
});

export default connect(mapStateToProps)(HeaderSearch);
